export const GAME_COLLECTION_ALL_COUNTRIES = 'default';

export const GAME_COLLECTION_KEY_DIVIDER = '***';

export const GameCollectionMatchOp = {
  ANY_OF: 'anyOf',
  ALL_OF: 'allOf',
} as const;
